import updateSendAsMruAddresses from '../services/updateSendAsMruAddresses';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { updateUserConfiguration } from 'owa-session-store/lib/actions/updateUserConfiguration';

export default function removeSendAsAddressFromMru(indexToRemove: number) {
    if (indexToRemove < getUserConfiguration().UserOptions.SendAsMruAddresses.length) {
        updateUserConfiguration(config => {
            config.UserOptions.SendAsMruAddresses.splice(indexToRemove, 1);
        });
        updateSendAsMruAddresses();
    }
}
